<template>
  <b-col
    sm="12"
    class="mt-1 mb-1"
    :md="formElement.size ? formElement.size.md : 4"
    :lg="formElement.size ? formElement.size.lg : 3"
  >
    <hr v-if="formElement.type == 'seperator'" />

    <b-form-checkbox
      v-else-if="formElement.type == 'checkbox'"
      :id="formElement.name"
      v-model="inputVal"
      :disabled="formElement.disabled"
      class="mt-4"
      :name="formElement.name"
      :value="true"
      :unchecked-value="false"
    >
      {{ formElement.label }}
    </b-form-checkbox>

    <b-form-group
      v-else-if="formElement.type == 'select'"
      :id="`${formElement.name}-form-group`"
      :description="formElement.description"
    >
      <label
        v-if="!formElement.hideLabel"
        :for="formElement.name"
        class="d-block"
      >
        {{ formElement.label }}
        <span v-if="formElement.required" class="text-danger">*</span></label
      >
      <b-form-select
        :id="formElement.name"
        v-model="inputVal"
        :selected="formElement.selected"
        :disabled="formElement.disabled"
        :options="formElement.options"
        :required="formElement.required"
        :text-field="formElement.selectLabel"
        :value-field="formElement.selectValue"
      ></b-form-select>
    </b-form-group>

    <b-form-group
      v-else-if="formElement.type == 'textarea'"
      :id="`${formElement.name}-form-group`"
      :description="formElement.description"
    >
      <label
        v-if="!formElement.hideLabel"
        :for="formElement.name"
        class="d-block"
      >
        {{ formElement.label }}
        <span v-if="formElement.required" class="text-danger">*</span></label
      >

      <b-form-textarea
        :id="`${formElement.name}-form-group`"
        v-model="inputVal"
        rows="3"
        :required="formElement.required"
        @input="handleInputTextarea"
        @change="handleInputTextarea"
        max-rows="6"
      ></b-form-textarea>
    </b-form-group>

    <form-element-password
      v-else-if="formElement.type === 'password'"
      v-model="inputVal"
      :form-element="formElement"
    />

    <b-form-group
      v-else
      :id="`${formElement.name}-form-group`"
      :description="formElement.description"
    >
      <label
        v-if="!formElement.hideLabel"
        :for="formElement.name"
        class="d-block"
      >
        {{ formElement.label }}
        <span v-if="formElement.required" class="text-danger">*</span></label
      >
      <b-form-input
        :id="formElement.name"
        v-model="inputVal"
        :max="formElement.maxLength"
        :maxlength="formElement.maxLength"
        :disabled="formElement.disabled"
        :type="formElement.type"
        :required="formElement.required"
      ></b-form-input>
    </b-form-group>
  </b-col>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BCol,
  BFormSelect,
  BFormTextarea,
} from "bootstrap-vue";
import FormElementPassword from "@/components/form/FormElementPassword";
export default {
  components: {
    FormElementPassword,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BCol,
    BFormSelect,
    BFormTextarea,
  },
  props: {
    formElement: {
      type: Object,
      required: true,
    },
    value: {
      required: true,
      default: function () {
        return "";
      },
    },
    currentValue: {
      required: false,
      default: null,
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    valueLength() {
      return this.inputVal?.length ?? 0;
    },
  },
  created: function () {
    if (this.formElement.value) {
      this.inputVal = this.formElement.value;
    }

    
  },
  methods: {
    handleInputTextarea() {
      if (this.valueLength > this.formElement.maxLength) {
        this.inputVal = this.inputVal.slice(0, this.formElement.maxLength);
      }
    },
  },
};
</script>

<style></style>
